import { render, staticRenderFns } from "./ErrorLogBody.vue?vue&type=template&id=f5a0115c&scoped=true&"
import script from "./ErrorLogBody.vue?vue&type=script&lang=ts&"
export * from "./ErrorLogBody.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorLogBody.vue?vue&type=style&index=0&id=f5a0115c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a0115c",
  null
  
)

export default component.exports